jQuery(document).ready(function ($) {
    lazy($);
    $(window).on('scroll', function () {
        lazy($);
    });
});

function shouldLazyLoad(element) {
    var $this = $(element),
        $window = $(window),
        top_of_element = $this.offset().top,
        bottom_of_element = $this.offset().top + $this.outerHeight(),
        bottom_of_screen = $window.scrollTop() + $window.innerHeight(),
        top_of_screen = $window.scrollTop();

    return (bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element);
}

function lazy($) {
    $('[data-lazy-src]').each(function () {
        var url = $(this).data('lazy-src');
        if (!shouldLazyLoad(this) || url === null || url.trim() === '') {
            return;
        }
        $(this).attr('src', url).removeAttr('data-lazy-src');
    });
    $('[data-lazy-bg]').each(function () {
        var url = $(this).data('lazy-bg');
        if (!shouldLazyLoad(this) || url === null || url.trim() === '') {
            return;
        }
        $(this).css('background-image', 'url(' + url + ')').removeAttr('data-lazy-bg');
    });
}
